'use strict';

/**
 * Component for the storage selection
 *
 * @category   View
 * @module     collection.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var ChooseStorageModalLayout = require('modules/collection/modules/location/views/layout/choose-storage-modal');
var RestrictionModalView = require('modules/base/views/layout/restriction-storages-modal');

var template = require('../../templates/components/field-storage.hbs');

var StorageComponent = LayoutView.extend({
    template: template,

    className: function() {
        var field = this.getOption('field');

        return 'form-component component-' + _.camelToHyphen(field.type);
    },

    attributes:{
        'data-state': 'pending',
    },

    ui: {
        'container': '.form-component',
        'buttonChooseStorage': '[data-action="choose-storage"]',
        'storageInput': '[name="storageId"]',
        'buttonRemoveStorage': '[data-action="remove-storage"]',
    },

    events: {
        'click @ui.buttonChooseStorage': 'onActionChooseStorage',
        'click @ui.buttonRemoveStorage': 'onActionRemoveStorage',
    },

    /**
     * States for this component
     * @type {object}
     */
    STATES: {
        PENDING: 'pending',
        SELECTED: 'selected',
    },

    viewData: {
        field: function() {
            return this.getOption('field');
        },

        isGroupChild: function() {
            return this.getOption('isGroupChild');
        },
    },

    /**
     * Resets the states and data of the component
     */
    reset: function() {
        this.ui.buttonChooseStorage.html(App.t('collection::edit:storage:button-choose-storage'));
        this.ui.storageInput.val('');
        this.setState(this.STATES.PENDING);
    },

    onRender: function() {
        var field = this.getOption('field');

        this.reset();

        var storageId = this.model && this.model.get(field.name);

        if (storageId) {
            var storageModel = this.model.collection.catalog.storages.get(storageId);
            if (storageModel) {
                this.onStorageSelected(storageModel);
            }
        }

        if (this.getOption('restricted')) {
            this.$el.addClass('component-restricted');
        }
    },

    /**
     * Triggered, when storage should be selected
     */
    onActionChooseStorage: function() {
        if (this.getOption('restricted') === true) {
            this.showRestrictionModal();

            return;
        }

        App.addModal(new ChooseStorageModalLayout({
            showCreateMessage: false,
        }), {
            additionalClassName: 'modal-left modal-medium modal-select-location',
            onAfterClose: function(data) {
                if (data){
                    this.onStorageSelected(data.location);
                }
            }.bind(this),
        });
    },

    /**
     * Triggered, when storage should be removed
     */
    onActionRemoveStorage: function() {
        if (this.getOption('restricted') === true) {
            return;
        }

        this.reset();
    },

    /**
     * Triggered, when a storage is selected in model
     * @param {LocationModule.LocationModel} model The storage/location model
     */
    onStorageSelected: function(model) {
        if (this.getOption('restricted') === true) {
            return;
        }

        this.ui.buttonChooseStorage.text(model.get('pathShortened'));
        this.ui.storageInput.val(model.get('id'));
        this.setState(this.STATES.SELECTED);
    },

    /**
     * Sets the state of the component
     * @param {string} state The state to set
     */
    setState: function(state) {
        this.$el.attr('data-state', state);
    },

    showRestrictionModal: function(){
        var restrictionModalView = new RestrictionModalView({hasClose:true});
        var options = {
            additionalClassName: 'modal-center modal-restriction',
            additionalBgClassName: 'light-bg',
        };
        App.addModal(restrictionModalView, options);
    },

    getData: function() {
        var data = {};
        var field = this.getOption('field');

        var storageId = parseInt(this.$('[name="storageId"]').val(), 10);

        data[field.name] = _.isNaN(storageId) ? null : storageId;

        return data;
    },
});

module.exports = StorageComponent;